import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PersonIcon from "@material-ui/icons/Person";
import TimerIcon from "@material-ui/icons/Timer";
import VisibilityIcon from "@material-ui/icons/Visibility";
import RefreshIcon from "@material-ui/icons/Refresh";
import EditCalendarIcon from "@material-ui/icons/Edit";
import managerTestApi from "api/managerTest";
import clsx from "clsx";
import { AnswerContent, AnswerRight, ExamQuestions, ListExam } from "models/managerTest";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Element } from "react-scroll";
import { timeConvert } from "utils/timeConvert";
import RescheduleExamModal from "./RescheduleExamModal";

const useStyles = makeStyles((theme: any) => ({
  container: {
    paddingTop: 28,
    paddingBottom: 48,
    position: "relative",
    [theme.breakpoints?.down("sm")]: {
      paddingTop: 12,
      paddingBottom: 16,
      paddingLeft: "0px !important",
      paddingRight: "0px !important",
    },
  },
  mobileNavigationBox: {
    display: "none",
    [theme.breakpoints?.down("sm")]: {
      display: "block",
      position: "sticky",
      top: 68,
      zIndex: 990,
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
      padding: "12px 16px",
      marginBottom: 20,
    },
  },
  mobileNavigationHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  horizontalScrollGrid: {
    display: "flex",
    overflowX: "auto",
    gap: 8,
    padding: "10px 2px 4px 2px",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  horizontalBadge: {
    minWidth: 38,
    height: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 13,
    cursor: "pointer",
    flexShrink: 0,
    transition: "all 0.2s ease",
    backgroundColor: "#EEF2FF",
    color: "#4F46E5",
  },
  backButton: {
    marginBottom: 20,
    color: "#475569",
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "none",
    borderRadius: 10,
    padding: "6px 14px",
    backgroundColor: "#F8FAFC",
    border: "1px solid #E2E8F0",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#F1F5F9",
      color: "#0F172A",
      transform: "translateX(-2px)",
    },
  },
  headerBanner: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
    borderRadius: 24,
    padding: "32px 36px",
    color: "#FFFFFF",
    marginBottom: 28,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(15, 23, 42, 0.25)",
    [theme.breakpoints?.down("sm")]: {
      padding: "20px 18px",
      borderRadius: 16,
    },
  },
  headerGlow: {
    position: "absolute",
    top: "-40%",
    right: "-10%",
    width: 350,
    height: 350,
    background: "radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, rgba(99, 102, 241, 0) 70%)",
    pointerEvents: "none",
  },
  headerBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    backdropFilter: "blur(8px)",
    padding: "4px 14px",
    borderRadius: 20,
    fontSize: "0.75rem",
    fontWeight: 800,
    color: "#818CF8",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginBottom: 12,
    border: "1px solid rgba(255, 255, 255, 0.15)",
  },
  headerTitle: {
    fontSize: "1.75rem",
    fontWeight: 900,
    color: "#FFFFFF",
    marginBottom: 16,
    [theme.breakpoints?.down("sm")]: {
      fontSize: "1.25rem",
    },
  },
  metricGroup: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
  },
  metricPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: 12,
    padding: "8px 16px",
    fontSize: "0.875rem",
    fontWeight: 800,
    color: "#FFFFFF",
    border: "1px solid rgba(255, 255, 255, 0.15)",
  },
  desktopSidebarGrid: {
    [theme.breakpoints?.down("sm")]: {
      display: "none",
    },
  },
  sidebarCard: {
    position: "sticky",
    top: 100,
    padding: 24,
    borderRadius: 20,
    border: "1px solid #E2E8F0",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.03)",
  },
  sidebarTitle: {
    fontSize: "1.05rem",
    fontWeight: 800,
    color: "#0F172A",
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
  },
  progressBox: {
    marginBottom: 24,
  },
  progressStats: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.85rem",
    fontWeight: 700,
    color: "#64748B",
    marginBottom: 8,
  },
  questionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 10,
    marginBottom: 24,
  },
  questionBadge: {
    aspectRatio: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    fontSize: "0.875rem",
    fontWeight: 800,
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "#EEF2FF",
    color: "#4F46E5",
    "&:hover": {
      transform: "translateY(-1px)",
      backgroundColor: "#4F46E5",
      color: "#FFFFFF",
    },
  },
  legendBox: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    borderTop: "1px solid #E2E8F0",
    paddingTop: 16,
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#64748B",
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: 4,
  },
  questionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: 28,
    border: "1px solid #E2E8F0",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.03)",
    marginBottom: 20,
    transition: "all 0.2s ease",
    [theme.breakpoints?.down("sm")]: {
      padding: 18,
      borderRadius: 16,
    },
  },
  questionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 14,
    gap: 12,
    flexWrap: "wrap",
  },
  questionHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  questionBadgeText: {
    backgroundColor: "#EEF2FF",
    color: "#4F46E5",
    fontWeight: 900,
    fontSize: "0.825rem",
    padding: "4px 12px",
    borderRadius: 10,
    letterSpacing: "0.04em",
  },
  questionText: {
    fontSize: "1.1rem",
    fontWeight: 800,
    color: "#0F172A",
    lineHeight: 1.5,
    marginBottom: 18,
    [theme.breakpoints?.down("sm")]: {
      fontSize: "0.95rem",
    },
  },
  formAnswers: {
    marginTop: 12,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  answerOptionBox: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: 12,
    border: "1px solid #E2E8F0",
    transition: "all 0.2s ease",
    backgroundColor: "#F8FAFC",
  },
  answerOptionBoxCorrect: {
    backgroundColor: "#ECFDF5",
    borderColor: "#A7F3D0",
    boxShadow: "0 2px 8px rgba(16, 185, 129, 0.08)",
  },
  answerContent: {
    fontSize: 14,
    color: "#334155",
    fontWeight: 500,
    marginLeft: 8,
  },
  scrollControlBox: {
    position: "fixed",
    right: 28,
    bottom: 32,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    zIndex: 100,
    [theme.breakpoints?.down("sm")]: {
      right: 16,
      bottom: 20,
    },
  },
  scrollBtn: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    color: "#4F46E5",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
    border: "1px solid #E2E8F0",
    minWidth: 0,
    padding: 0,
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#4F46E5",
      color: "#FFFFFF",
    },
  },
  btnActionBanner: {
    borderRadius: 12,
    padding: "8px 16px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "0.85rem",
  },
}));

export default function DetailExam() {
  const params = useParams();
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [detailExam, setDetailExam] = useState<ListExam>();
  const [detailExamHasAnswer, setDetailExamHasAnswer] = useState<ListExam>();
  const [studentPreview, setStudentPreview] = useState<ListExam | null>(null);
  const [loading, setLoading] = useState(true);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [rescheduleOpen, setRescheduleOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [loading]);

  const reloadExam = async () => {
    try {
      const res: ListExam = await managerTestApi.getDetailExam(Number(params.id));
      setDetailExam(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [resExam, resAnswer] = await Promise.all([
          managerTestApi.getDetailExam(Number(params.id)),
          managerTestApi.getDetailExamHasAnswers(Number(params.id)),
        ]);
        setDetailExam(resExam);
        setDetailExamHasAnswer(resAnswer);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [params.id]);

  const handleToggleStudentPreview = async () => {
    if (studentPreview) {
      setStudentPreview(null);
      return;
    }
    setLoadingPreview(true);
    try {
      const res: ListExam = await managerTestApi.getDetailExam(Number(params.id), true);
      setStudentPreview(res);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleSelectQuestion = (index: number) => {
    const targetId = `question-${index}`;
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleScrollTop = () => {
    const banner = document.getElementById("header-banner");
    if (banner) {
      banner.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleScrollBottom = () => {
    const footer = document.getElementById("footer-scroll-marker");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth", block: "end" });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  };

  const activeExam = studentPreview ?? detailExam;
  const displayedQuestions = activeExam?.exam?.examQuestions ?? [];
  const totalQuestions = detailExam?.exam?.examQuestions?.length ?? displayedQuestions.length;
  const isPreviewMode = studentPreview != null;
  const examInfo = detailExam?.exam;
  const isEssay = examInfo?.type?.toUpperCase() === "TYPING" || examInfo?.type?.toUpperCase() === "ESSAY";

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={8} style={{ minHeight: "450px" }}>
        <CircularProgress style={{ color: "#4F46E5" }} size={48} />
        <Typography variant="body1" style={{ marginTop: 16, color: "#0F172A", fontWeight: 600 }}>
          Đang tải chi tiết đề thi...
        </Typography>
      </Box>
    );
  }

  return (
    <div ref={containerRef}>
      <Container maxWidth="lg" className={classes.container}>
        {/* Back Button */}
        <Button
          onClick={() => navigate(-1)}
          className={classes.backButton}
          startIcon={<ArrowBackIcon />}
        >
          {t("button.goback") || "Quay lại"}
        </Button>

        {/* Header Banner */}
        <Box className={classes.headerBanner} id="header-banner">
          <Box className={classes.headerGlow} />
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" style={{ gap: 16 }}>
            <Box>
              <Box className={classes.headerBadge}>
                {isEssay ? "TỰ LUẬN" : "TRẮC NGHIỆM"}
              </Box>
              <Typography className={classes.headerTitle}>
                {examInfo?.examTitle || "Chi tiết đề thi"}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 10 }}>
              <Button
                variant="contained"
                startIcon={<EditCalendarIcon style={{ fontSize: 18 }} />}
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                  color: "#FFFFFF",
                  backdropFilter: "blur(8px)",
                }}
                className={classes.btnActionBanner}
                onClick={() => setRescheduleOpen(true)}
              >
                {t("managerTest.doilichthi") || "Đổi lịch thi"}
              </Button>

              <Button
                variant={isPreviewMode ? "contained" : "outlined"}
                startIcon={<VisibilityIcon style={{ fontSize: 18 }} />}
                disabled={loadingPreview}
                style={{
                  backgroundColor: isPreviewMode ? "#38BDF8" : "transparent",
                  color: "#FFFFFF",
                  borderColor: isPreviewMode ? "#38BDF8" : "rgba(255, 255, 255, 0.3)",
                }}
                className={classes.btnActionBanner}
                onClick={handleToggleStudentPreview}
              >
                {loadingPreview ? "Đang tải..." : isPreviewMode ? "Xem tất cả" : "Xem thử như học viên"}
              </Button>

              {isPreviewMode && (
                <Button
                  variant="outlined"
                  startIcon={<RefreshIcon style={{ fontSize: 18 }} />}
                  disabled={loadingPreview}
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    color: "#FFFFFF",
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  }}
                  className={classes.btnActionBanner}
                  onClick={async () => {
                    setLoadingPreview(true);
                    try {
                      const res: ListExam = await managerTestApi.getDetailExam(Number(params.id), true);
                      setStudentPreview(res);
                    } finally {
                      setLoadingPreview(false);
                    }
                  }}
                >
                  Tráo câu mới
                </Button>
              )}
            </Box>
          </Box>

          <Box className={classes.metricGroup} mt={1}>
            <Box className={classes.metricPill}>
              <TimerIcon style={{ fontSize: 18 }} />
              <span>Thời gian thi: {timeConvert(examInfo?.examTime)}</span>
            </Box>
            <Box className={classes.metricPill}>
              <EmojiEventsIcon style={{ fontSize: 18, color: "#F59E0B" }} />
              <span>Tổng điểm: {examInfo?.totalPoint || 0} điểm</span>
            </Box>
            <Box className={classes.metricPill}>
              <PersonIcon style={{ fontSize: 18 }} />
              <span>Mã đề: #{examInfo?.id}</span>
            </Box>
            {examInfo?.startDate && (
              <Box className={classes.metricPill}>
                <span>📅 Ngày thi: {moment(examInfo.startDate).format("HH:mm - DD/MM/YYYY")}</span>
              </Box>
            )}
          </Box>
        </Box>

        {/* Mobile Sticky Question Navigator */}
        <Box className={classes.mobileNavigationBox}>
          <Box
            className={classes.mobileNavigationHeader}
            onClick={() => setMobileExpanded(!mobileExpanded)}
          >
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
              <AssignmentTurnedInIcon color="primary" style={{ fontSize: 20 }} />
              <Typography style={{ fontWeight: 800, fontSize: "0.9rem", color: "#0F172A" }}>
                Danh sách câu hỏi ({displayedQuestions.length} câu)
              </Typography>
            </Box>
            <IconButton size="small" style={{ padding: 4 }}>
              {mobileExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Box>

          {!mobileExpanded && (
            <Box className={classes.horizontalScrollGrid}>
              {displayedQuestions.map((_: any, index: number) => (
                <Box
                  key={index}
                  onClick={() => handleSelectQuestion(index)}
                  className={classes.horizontalBadge}
                >
                  {index + 1}
                </Box>
              ))}
            </Box>
          )}

          <Collapse in={mobileExpanded}>
            <Box style={{ paddingTop: 12 }}>
              <Box className={classes.questionGrid}>
                {displayedQuestions.map((_: any, index: number) => (
                  <Box
                    key={index}
                    onClick={() => {
                      handleSelectQuestion(index);
                      setMobileExpanded(false);
                    }}
                    className={classes.questionBadge}
                  >
                    {index + 1}
                  </Box>
                ))}
              </Box>
            </Box>
          </Collapse>
        </Box>

        {/* 2-Column Grid Layout: Left Sidebar + Right Questions Stream */}
        <Grid container spacing={3}>
          {/* Left Column: Sidebar Navigator */}
          <Grid item xs={12} md={4} lg={3} className={classes.desktopSidebarGrid}>
            <Paper className={classes.sidebarCard} elevation={0}>
              <Typography className={classes.sidebarTitle}>
                <AssignmentTurnedInIcon color="primary" />
                DANH SÁCH CÂU HỎI
              </Typography>

              <Box className={classes.progressBox}>
                <Box className={classes.progressStats}>
                  <span>Số câu trong bài</span>
                  <span>{displayedQuestions.length} / {totalQuestions} câu</span>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={(displayedQuestions.length / (totalQuestions || 1)) * 100}
                  style={{ height: 8, borderRadius: 4, backgroundColor: "#E2E8F0" }}
                />
              </Box>

              <Box className={classes.questionGrid}>
                {displayedQuestions.map((_: any, index: number) => (
                  <Box
                    key={index}
                    onClick={() => handleSelectQuestion(index)}
                    className={classes.questionBadge}
                  >
                    {index + 1}
                  </Box>
                ))}
              </Box>

              <Box className={classes.legendBox}>
                <Box className={classes.legendItem}>
                  <Box className={classes.legendDot} style={{ backgroundColor: "#4F46E5" }} />
                  <span>Câu hỏi trong đề ({displayedQuestions.length})</span>
                </Box>
                {isPreviewMode && (
                  <Box className={classes.legendItem}>
                    <Box className={classes.legendDot} style={{ backgroundColor: "#0284C7" }} />
                    <span>Học viên thấy ngẫu nhiên {displayedQuestions.length} câu</span>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>

          {/* Right Column: Question Content Stream */}
          <Grid item xs={12} md={8} lg={9}>
            {displayedQuestions.map((question: ExamQuestions, index: number) => (
              <Element name={`question-${index}`} id={`question-${index}`} key={question.id || index}>
                <Paper
                  className={classes.questionCard}
                  elevation={0}
                >
                  <Box className={classes.questionHeader}>
                    <Box className={classes.questionHeaderLeft}>
                      <Box className={classes.questionBadgeText}>
                        {t("test.cau") || "CÂU"} {index + 1} / {displayedQuestions.length}
                      </Box>
                      <Chip
                        label={`Điểm: ${question.question?.point || 0}`}
                        size="small"
                        style={{ backgroundColor: "#ECFDF5", color: "#047857", fontWeight: 800 }}
                      />
                    </Box>
                  </Box>

                  <Typography className={classes.questionText}>
                    {question.question?.content}
                  </Typography>

                  {question.question?.imageFileList?.length > 0 && (
                    <Box
                      display="grid"
                      gridTemplateColumns={
                        question?.question?.imageFileList?.length === 1 ? "1fr" : "1fr 1fr"
                      }
                      gridGap={14}
                      my={2}
                    >
                      {question.question.imageFileList.map((x: any) => (
                        <img
                          key={x.id}
                          style={{
                            width: "100%",
                            height: "auto",
                            objectFit: "contain",
                            maxHeight: 400,
                            borderRadius: 12,
                            border: "1px solid #E2E8F0",
                          }}
                          src={x.imageFile?.url}
                          alt="Hình câu hỏi"
                        />
                      ))}
                    </Box>
                  )}

                  <Box className={classes.formAnswers}>
                    {detailExamHasAnswer?.questions?.map(
                      (answerRight: AnswerRight) =>
                        answerRight.questionId === question.questionId &&
                        answerRight?.answers?.map((answer: AnswerContent) =>
                          isEssay ? (
                            <Box
                              key={answer.id || answer.answerContent}
                              p={2}
                              style={{
                                backgroundColor: "#F0F9FF",
                                border: "1px solid #BAE6FD",
                                borderRadius: 12,
                              }}
                            >
                              <Typography variant="caption" style={{ color: "#0369A1", fontWeight: 700, display: "block", marginBottom: 4 }}>
                                ĐÁP ÁN MẪU / HƯỚNG DẪN CHẤM:
                              </Typography>
                              <Typography style={{ color: "#0C4A6E", fontWeight: 500, fontSize: "0.95rem" }}>
                                {answer?.content || answer?.answerContent}
                              </Typography>
                            </Box>
                          ) : (
                            <Box
                              key={answer.id || answer.answerContent}
                              className={clsx(
                                classes.answerOptionBox,
                                answer.isRightAnswer && classes.answerOptionBoxCorrect
                              )}
                            >
                              {answer.isRightAnswer ? (
                                <CheckCircleIcon style={{ color: "#10B981", fontSize: 20 }} />
                              ) : (
                                <RadioButtonUncheckedIcon style={{ color: "#94A3B8", fontSize: 20 }} />
                              )}
                              <Typography
                                className={classes.answerContent}
                                style={{
                                  fontWeight: answer.isRightAnswer ? 700 : 500,
                                  color: answer.isRightAnswer ? "#065F46" : "#334155",
                                }}
                              >
                                {answer?.content || answer?.answerContent}
                              </Typography>
                            </Box>
                          )
                        )
                    )}
                  </Box>
                </Paper>
              </Element>
            ))}
          </Grid>
        </Grid>

        {/* Scroll Controls (Floating Buttons) */}
        <Box className={classes.scrollControlBox}>
          <Tooltip title="Cuộn lên đầu trang">
            <IconButton
              className={classes.scrollBtn}
              onClick={handleScrollTop}
            >
              <ArrowUpwardIcon style={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cuộn xuống cuối trang">
            <IconButton
              className={classes.scrollBtn}
              onClick={handleScrollBottom}
            >
              <ArrowDownwardIcon style={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        </Box>

        <div id="footer-scroll-marker" style={{ height: 1 }} />

        {/* Reschedule Exam Modal */}
        <RescheduleExamModal
          open={rescheduleOpen}
          exam={
            detailExam?.exam
              ? {
                  id: detailExam.exam.id ?? Number(params.id),
                  examTitle: detailExam.exam.examTitle,
                  startDate: detailExam.exam.startDate,
                  examTime: detailExam.exam.examTime,
                }
              : null
          }
          onClose={() => setRescheduleOpen(false)}
          onSuccess={reloadExam}
        />
      </Container>
    </div>
  );
}
